import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

// Importe as imagens desejadas
import bgLogin1 from "../images/login/01.jpg";
import bgLogin2 from "../images/login/02.jpg";
import bgLogin3 from "../images/login/03.jpg";
import bgLogin4 from "../images/login/04.jpg";
import bgLogin5 from "../images/login/05.jpg";

import fmsIcon from "../images/logo-fms-login.png";

// Modal simples
const Modal = ({ show, onClose }) => {
  if (!show) return null;
  return (
    <div className="modal-overlay" style={modalOverlayStyle}>
      <div className="modal-content" style={modalContentStyle}>
        <h3>Recuperação de Senha</h3>
        <p>
          Para recuperar sua senha, entre em contato com o administrador do sistema.
        </p>
        <button className="btn btn-primary" onClick={onClose}>
          Fechar
        </button>
      </div>
    </div>
  );
};

// Estilos inline para o modal (você pode adaptar para sua classe CSS)
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalContentStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
  maxWidth: "400px",
  width: "90%",
  textAlign: "center",
};

function Login() {
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Array com as imagens de fundo
  const bgImages = [bgLogin1, bgLogin2, bgLogin3, bgLogin4, bgLogin5];

  // Estado para o índice da imagem atual
  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  // No carregamento do componente, define um índice aleatório para a imagem de fundo
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * bgImages.length);
    setCurrentBgIndex(randomIndex);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await loginUser(credentials.username, credentials.password);
    if (success) {
      navigate("/");
    } else {
      setError("Usuário ou senha incorretos. Tente novamente.");
    }
  };

  return (
    <div className="row g-0 flex-fill">
      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-primary d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center mb-4">
            <a href="." className="navbar-brand navbar-brand-autodark">
              <img 
                src={fmsIcon} 
                alt="Logo Fundo Manaus Solidaria"
                width="110" 
                height="110"
                style={{
                  display: "block",
                  margin: "0 auto",
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: 50,
                }}
              />
            </a>
          </div>
          <h2 className="h3 text-center mb-3">Login na sua conta</h2>
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <div className="mb-3">
              <label className="form-label">Usuário</label>
              <input
                tabIndex={1}
                type="text"
                className="form-control"
                placeholder="Digite seu nome de usuário"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-2">
              <label className="form-label">
                Senha
                <span className="form-label-description">
                  {/* Ao invés de linkar para outra página, abrimos o modal */}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowModal(true);
                    }}
                  >
                    Esqueci minha senha
                  </a>
                </span>
              </label>
              <div className="input-group input-group-flat">
                <input
                  tabIndex={2}
                  type="password"
                  className="form-control"
                  placeholder="Digite sua senha"
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="form-footer">
              <button type="submit" className="btn btn-primary w-100">
                Entrar
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Área da imagem de fundo com imagem aleatória */}
      <div className="col-12 col-lg-6 col-xl-8 d-none d-lg-block">
        <div
          className="bg-cover h-100 min-vh-100"
          style={{
            backgroundImage: `url(${bgImages[currentBgIndex]})`,
            backgroundPosition: "center bottom",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transition: "background-image 0.5s ease-in-out",
          }}
        ></div>
      </div>

      {/* Modal de Esqueci Minha Senha */}
      <Modal show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

export default Login;